import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import {
  BoxComponent,
  DownloadComponent,
  EnvelopeComponent,
  ExcelComponent,
  IsfFileComponent,
  MoneyBagComponent,
  MoneyClockComponent,
  PlusComponent,
  PoaErrorComponent,
  PoaPendingComponent,
  PoaPlusComponent,
  PoaUploadedComponent,
  QuestionCircleComponent,
  ShapeComponent,
  ToggleOpenCloseComponent,
} from './components';

@NgModule({
  declarations: [
    IsfFileComponent,
    BoxComponent,
    ToggleOpenCloseComponent,
    PoaPlusComponent,
    PoaUploadedComponent,
    DownloadComponent,
    PlusComponent,
    ShapeComponent,
    QuestionCircleComponent,
    MoneyClockComponent,
    MoneyBagComponent,
    ExcelComponent,
    PoaErrorComponent,
    PoaPendingComponent,
    EnvelopeComponent,
  ],
  imports: [CommonModule],
  exports: [
    IsfFileComponent,
    BoxComponent,
    ToggleOpenCloseComponent,
    PoaPlusComponent,
    PoaUploadedComponent,
    DownloadComponent,
    PlusComponent,
    ShapeComponent,
    QuestionCircleComponent,
    MoneyClockComponent,
    MoneyBagComponent,
    ExcelComponent,
    PoaErrorComponent,
    PoaPendingComponent,
    EnvelopeComponent,
  ],
})
export class IconsModule {}
